import { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useFormContext } from "@4uhub/lib4uhub";
import { IIServiceType } from "../../../../../../../models/i-service-type";
import { TIServiceForm } from "../../iServiceSchema";
import { IServiceType } from "../IServiceType";
import { useIServiceType } from "../useIServiceType";
import { ShiftLIS } from "./ShiftLIS";

interface IShiftLISWrapperProps {
  iServiceTypes: IIServiceType[];
}

const FIELD_NAME = "shiftLis";

const SHIFT_LIS_IMAGE = { src: "/iServices/shift-lis.png", alt: "Shift LIS" };

const translationPath = "page.4uBus.register.iService.";

export const ShiftLISWrapper = memo(
  ({ iServiceTypes }: IShiftLISWrapperProps) => {
    const { id } = useParams();

    const { t } = useTranslation();

    const { setValue, getValues } = useFormContext<TIServiceForm>();

    const { shiftLisValues } = useIServiceType();

    const shiftLisType = iServiceTypes.find(
      (item) => item.code === shiftLisValues.code,
    );

    const [isSelected, setIsSelected] = useState(() => {
      const shiftLis = getValues(FIELD_NAME);
      const iServiceType = getValues("iServiceType");
      return !!shiftLis || iServiceType?.code === shiftLisValues.code;
    });

    const handleConfirm = () => {
      if (shiftLisType) {
        setValue("iServiceType", shiftLisType);
      }
      setValue(FIELD_NAME, shiftLisValues.defaultValues);
      setIsSelected(true);
    };

    const handleClearConfigs = () => {
      setValue("configs", null);
      setValue("companyDigitalCertificate", null);
      setValue("iServiceType", null);
      setValue(FIELD_NAME, null);
      setIsSelected(false);
    };

    const handleOpen = () => {
      setValue(FIELD_NAME, shiftLisValues.defaultValues);
    };

    const handleCloseSelected = () => {
      setValue(FIELD_NAME, shiftLisValues.defaultValues);
    };

    const isEditingScreen = !!id;

    if (!shiftLisType) {
      return null;
    }

    return (
      <IServiceType
        img={SHIFT_LIS_IMAGE}
        renderComponent={() => <ShiftLIS />}
        isSelected={isSelected}
        isEditingScreen={isEditingScreen}
        getFormattedData={() => ({})}
        onConfirm={handleConfirm}
        onClearConfigs={handleClearConfigs}
        onOpen={handleOpen}
        onCloseSelected={handleCloseSelected}
        iServiceTypeName={FIELD_NAME}
        serviceName={t(translationPath + "shift_lis")}
        showConfirmButton={false}
      />
    );
  },
);
